import axios from "axios";

export const getPublishers = async (params) => {
    try {
        let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/publishers`,{params});
        return data
    } catch (error) {
        return error?.response?.data
    }
}